import React from 'react';
import Markdown from 'react-markdown';
import {Box, Stack, styled, Typography} from '@mui/material';

const MarkdownWrapper = styled(props=>{
    let {className, content} = props;
    return <Box className={className}>
      <Markdown>
        {content}
      </Markdown>
    </Box>;
})`
    img {
        max-width: 400px;
    }
    p {
        line-height: 10px;
    }
`;

const BlogPostComp = styled(props=>{
    let {content, className, title} = props;
    return  <Stack className={className} direction="column">
      {title&&<Typography variant="h3">
        {title}
      </Typography>}
      <MarkdownWrapper content={content}/>
    </Stack>;
})`
    direction: rtl;
`;


const BlogPost = props=>{
    return <BlogPostComp {...props}/>;
};

export default BlogPost;
